<template>
    <div>
        <div class="card-header w-100 d-flex align-items-center">
            <h3 class="card-title">Plazas del recinto</h3>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-12">
                    <ContentOrLoading>
                        <div v-if="plazas.length > 0">
                            <div v-for="(plaza, index) in originalPlazas" class="row mb-4" :key="index">
                                <div class="col-12 col-md-10">
                                    <div class="row">
                                        <div class="col-12 ">
                                            <span class="" v-if="plaza.butaca">
                                                <small>Sector: {{ plaza.sector_name }}</small><br/>
                                                <strong> Fila: {{ plaza.fila }} - Butaca: {{ plaza.butaca }} /</strong>
                                                <strong class="text-danger">
                                                    Visibilidad Reducida
                                                    <span v-if="plaza.porcentaje_visibilidad !== null">
                                                        : {{ plaza.porcentaje_visibilidad }} %
                                                    </span>
                                                </strong>
                                            </span>
                                            <strong v-else>{{ plaza.name }}</strong>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div> 
                            <label for="descuento">Descuento:</label>    
                            <FormInput 
                                name="descuento" 
                                rules="required"
                                type="number" 
                                v-model="descuento_visibilidad_reducida" 
                                min="0" 
                                max="100"
                            />
                        </div>

                        <div v-if="!esMovil" class="pt-2">
                            <Button 
                                @click.prevent="guardarDescuentos()" 
                                class="btn btn-block"
                                :disabled="!validarDescuento"
                            >
                                Guardar
                            </Button>
                        </div>
                        <div v-if="esMovil" class="col-12 col-md-2 text-right pt-4 mt-md-0">
                            <Button 
                                @click.prevent="guardarDescuentos()" 
                                class="btn btn-block"
                                :disabled="loadingButacas"
                            >
                                Guardar
                            </Button>
                        </div>
                    </ContentOrLoading>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        props: ['plazas', 'region', 'recinto_id'],
        data() {
            return {
                originalPlazas: [],
                loadingButacas: false,
                esMovil: false,
                descuento_visibilidad_reducida: null
            }
        },
        created() {
            this.esMovil = window.innerWidth <= 768;
            this.originalPlazas = this.plazas;
        },
        computed: {
            validarDescuento() {
                return this.descuento_visibilidad_reducida !== null && this.descuento_visibilidad_reducida > 0 && this.descuento_visibilidad_reducida <= 100;
            }
        },
        methods: {
            guardarDescuentos() {
                this.loadingButacas = true;

                const formattedPlazas = this.originalPlazas.map(plaza => plaza.id);

                const params = {
                    filters: {}, 
                    butacas: formattedPlazas,
                    descuento: this.descuento_visibilidad_reducida,
                    evento_id: this.$route.params.evento_id, 
                    recinto_id: this.recinto_id
                };


                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.settings.butacas.visibilidad-reducida.update'), params)
                    .then(() => {
                        this.$emit('recargar', null, 'porPlazas');
                        this.$emit('getButacas');
                        this.$toast.success('Precios guardados correctamente!');
                        this.loadingButacas = false;
                    }).catch(() => {
                        this.$toast.error('Ha ocurrido un error al guardar los precios');
                    });
            },
            volver() {
                this.originalPlazas = null,
                this.$emit('volver');
            }
        }
    }
</script>